import {CSSProperties} from 'react';
import {BiolinkGlassConfig} from '@app/dashboard/biolink/biolink';

// fallback classnames used before per-page intensity controls existed
export const glassButtonClassnames =
  'border-white/30 bg-white/15 text-white backdrop-blur-md hover:bg-white/25';

export const DefaultGlassOpacity = 15;
export const DefaultGlassBlur = 16;

export function getGlassStyle(config?: BiolinkGlassConfig): CSSProperties {
  const opacity = (config?.opacity ?? DefaultGlassOpacity) / 100;
  const blur = config?.blur ?? DefaultGlassBlur;
  const borderOpacity = Math.min(opacity * 2, 0.4);
  return {
    backgroundColor: `rgba(255, 255, 255, ${opacity})`,
    borderColor: `rgba(255, 255, 255, ${borderOpacity})`,
    backdropFilter: `blur(${blur}px)`,
    WebkitBackdropFilter: `blur(${blur}px)`,
    color: '#fff',
  };
}
